<template>
    <div class="container">
        <div class="layout">
            <div class="container-inner clearfix mt25">

                <section class="survey">
                    <h1>预约信息</h1>
                    <div id="formwrap" data-id="53"><div class="survey-info" style="text-align:left;">
                        <div style="margin-left:40%">姓名:<span id="lbName">{{username}}</span></div>
                        <div style="margin-left:40%">联系方式:<span id="lbTel">{{mobile}}</span></div>
                        <div style="margin-left:40%">身份证号:<span id="lbCardnumber">{{sid}}</span></div>
                        <div style="margin-left:40%">预约医生:<span id="lbKs">{{doctor.job}}</span>&nbsp;&nbsp;<span id="lbDoctor">{{doctor.name}}</span></div>
                        <div style="margin-left:40%">预约时间:<span id="lbDate">{{schedule.date}}</span>&nbsp;&nbsp;<span id="lbTime">{{type}}</span></div>
                    </div>
                        <div class="mt25 text-center">
                            <input type="submit"  @click="addAppoint" name="btnOk" value="确认" class="btn">
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>

</template>
<script>
    export default {
        name: 'AppointInfo',
        data(){
            return{
                user_id:0,
                doctor:[],
                schedule:[],
                type_id:0,
                type:'',
                username:'',
                mobile:'',
                sid:''
            }
        },
        props:['info'],
        watch:{
            info:function(e) {
                this.getInfo(e);
            }
        },
        methods:{
            getInfo:function(e){
                console.log(e.schedule);
                this.doctor = e.doctor;
                this.schedule = e.schedule;
                this.type_id = e.type;
                if(e.type==1){
                    this.type = '上午';
                }else{
                    this.type = '下午';
                }
            },
            addAppoint:function () {
                let that = this;
                let data = {
                    user_id:that.user_id,
                    doctor_id:that.doctor.id,
                    schedule_id:that.schedule.id,
                    type_id:that.type_id,
                };
                that.$http.post(this.$api.userAppoint.url,{},data).then(result => {
                    if(result.status==200){
                        alert('操作成功');
                        that.$router.push({name: 'Home'});
                    }else{
                        alert('操作失败');
                    }
                });
            }
        },
        mounted(){
            let user = sessionStorage.getItem('userinfo');
            if(!user){
                alert('请登录');
                this.$router.push({name: 'Login'});
            }else{
                user = JSON.parse(user);
                this.user_id = user.id;
                this.username = user.username;
                this.mobile = user.mobile;
                this.sid = user.sid;
            }

            //this.getDoctorInfo(107);
        }
    }
</script>